import { FormElement } from './form-element.model';
import { NameValueInteger, NameValueString, NameValue } from '../../../shared/index';

export class FormElementDropDownIntegerValue extends FormElement {
  public constructor() {
    super();
    this.intialize();
  }

  public intialize = (): void => {
    this.Value = 0;
    this.Items = new Array<NameValueInteger>();
    this.ProposedItemName = '';
    this.ProposedItemValue = 0;
    this.SelectedValue = 0;
    this.ElementTypeId = 4;
  };

  public Value: number;
  public Items: Array<NameValueInteger>;
  public ProposedItemName: string;
  public ProposedItemValue: number;
  public SelectedValue: number;
}
